export var AutopilotChatMode;
(function (AutopilotChatMode) {
    AutopilotChatMode["Closed"] = "closed";
    AutopilotChatMode["SideBySide"] = "side-by-side";
    AutopilotChatMode["FullScreen"] = "full-screen";
})(AutopilotChatMode || (AutopilotChatMode = {}));
export var AutopilotChatAccordionPosition;
(function (AutopilotChatAccordionPosition) {
    AutopilotChatAccordionPosition["Left"] = "left";
    AutopilotChatAccordionPosition["Right"] = "right";
})(AutopilotChatAccordionPosition || (AutopilotChatAccordionPosition = {}));
export var AutopilotChatFileType;
(function (AutopilotChatFileType) {
    AutopilotChatFileType["Word"] = "Word";
    AutopilotChatFileType["PowerPoint"] = "PowerPoint";
    AutopilotChatFileType["File"] = "File";
})(AutopilotChatFileType || (AutopilotChatFileType = {}));
export var AutopilotChatRole;
(function (AutopilotChatRole) {
    AutopilotChatRole["User"] = "user";
    AutopilotChatRole["Assistant"] = "assistant";
})(AutopilotChatRole || (AutopilotChatRole = {}));
/**
 * Enum representing the various events that can occur in the Autopilot Chat system.
 * These events are used for communication between components and for event handling.
 *
 * @enum {string}
 * @property {string} Error - Emitted when an error occurs in the chat system
 * @property {string} NewChat - Emitted when a new chat session is started
 * @property {string} ModeChange - Emitted when the chat mode changes (e.g., from normal to full-screen)
 * @property {string} SetPrompt - Emitted when the chat prompt is set or changed
 * @property {string} Request - Emitted when a user sends a message request
 * @property {string} Response - Emitted when the assistant sends a response
 * @property {string} StopResponse - Emitted when a response is manually stopped
 * @property {string} SetFirstRunExperience - Emitted when the first run experience is configured
 * @property {string} SetDisabledFeatures - Emitted when disabled features are configured
 * @property {string} Open - Emitted when the chat is opened
 * @property {string} Close - Emitted when the chat is closed
 * @property {string} SendChunk - Emitted when a chunk of a streaming response is sent
 * @property {string} SetConversation - Emitted when the conversation is set
 */
export var AutopilotChatEvent;
(function (AutopilotChatEvent) {
    AutopilotChatEvent["Error"] = "error";
    AutopilotChatEvent["NewChat"] = "newChat";
    AutopilotChatEvent["ModeChange"] = "modeChange";
    AutopilotChatEvent["SetPrompt"] = "setPrompt";
    AutopilotChatEvent["Request"] = "request";
    AutopilotChatEvent["Response"] = "response";
    AutopilotChatEvent["StopResponse"] = "stopResponse";
    AutopilotChatEvent["SetFirstRunExperience"] = "setFirstRunExperience";
    AutopilotChatEvent["SetDisabledFeatures"] = "setDisabledFeatures";
    AutopilotChatEvent["Open"] = "open";
    AutopilotChatEvent["Close"] = "close";
    AutopilotChatEvent["SendChunk"] = "sendChunk";
    AutopilotChatEvent["SetConversation"] = "setConversation";
})(AutopilotChatEvent || (AutopilotChatEvent = {}));
/**
 * Enum representing the various interceptable events that can occur in the Autopilot Chat system.
 * These events are used for intercepting and preventing default handling of events.
 *
 * @enum {string}
 * @property {string} Request - Emitted when a user sends a message request
 */
export var AutopilotChatInterceptableEvent;
(function (AutopilotChatInterceptableEvent) {
    AutopilotChatInterceptableEvent["Request"] = "request";
})(AutopilotChatInterceptableEvent || (AutopilotChatInterceptableEvent = {}));
export var AutopilotChatInternalEvent;
(function (AutopilotChatInternalEvent) {
    AutopilotChatInternalEvent["ChatResize"] = "chatResize";
    AutopilotChatInternalEvent["ScrollToBottom"] = "scrollToBottom";
})(AutopilotChatInternalEvent || (AutopilotChatInternalEvent = {}));
